import { Link } from "react-router-dom";
import { BrandLogo } from "./BrandLogo";
import { ProgramDetails } from "../../services/program.service";

interface BrandCardProps {
  program: ProgramDetails;
  isJoined: boolean;
}

export const BrandCard = ({ program, isJoined }: BrandCardProps) => {
  const programId = program.id;

  return (
    <Link
      key={programId}
      to={`/affiliate/brands/${program.username || program.sessionId}`}
      className="block bg-card rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
    >
      <div className="aspect-square flex items-center justify-center mb-4">
        <BrandLogo
          src={program.brandProfileImage}
          name={program.companyName}
          className="w-[120px] h-[120px] rounded-lg text-3xl"
          imgClassName="object-contain"
        />
      </div>
      <h3 className="font-medium text-center break-words overflow-hidden text-ellipsis">{program.companyName}</h3>
      {isJoined && (
        <span className="block text-sm text-green-600 text-center mt-2">
          Joined
        </span>
      )}
    </Link>
  );
};
